import React from "react";
import { HomeSectionLink } from "../../shared/homeSectionNav";

function GuidanceSection() {
  return (
    <section className="about-us-section py-10 md:py-16 relative overflow-hidden">
      <div className="container">
        <div className="max-w-[950px] mx-auto text-center mb-8 md:mb-12">
          <span className="inline-flex items-center gap-2 tracking-[.2em] body-lg">
            <span className="w-[33px] h-[1px] bg-primary-500 inline-block"></span>
            GUIDANCE
          </span>
          <h2 className="web-h2 text-zinc-900 mt-3">
            Guidance that respects your journey
          </h2>
          <p className="web-body-sm text-zinc-600 mt-2">
            With personalized horoscopes, remedies, and consultations, we aim
            to bring positivity and balance to your journey
          </p>
        </div>

        <div className="flex items-center flex-wrap gap-[15px] md:gap-[30px] lg:gap-[50px]">
          <div className="hidden lg:block">
            <div className="overflow-hidden">
              <img
                src="/images/about.png"
                alt="Astrology guidance"
                className="object-cover aspect-[4/5]"
              />
            </div>
          </div>

          <div className="flex-1">
            <p className="text-zinc-700 web-body-lg !leading-relaxed mb-3">
              Every person's questions, circumstances and aspirations are
              different.
            </p>
            <p className="text-zinc-700 web-body-lg !leading-relaxed mb-3">
              AstroAdi brings together practitioners and experiences across
              astrology, numerology, tarot and spiritual guidance, giving you
              the opportunity to explore different perspectives in one place.
            </p>
            <p className="text-zinc-700 web-body-lg !leading-relaxed mb-6">
              Whether you are seeking an astrological reading, spiritual
              guidance or a space for personal reflection, your journey begins
              with what matters to you.
            </p>
            <div className="mb-6">
              <HomeSectionLink
                to="/download-app"
                className="custom-btn custom-btn-primary no-underline"
              >
                Explore Our Experts
              </HomeSectionLink>
            </div>

            <div className="key-points-bg">
              <h3 className="web-h5 mb-3">Key Points:</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-2">
                  <img src="/images/arrow.svg" alt="" />
                  <p className="web-body-md text-zinc-800">
                    🔮
                    <span className="font-semibold">Expert Astrologers:</span>{" "}
                    Verified professionals with years of experience in Vedic
                    astrology, tarot, and numerology.
                  </p>
                </div>

                <div className="flex items-start gap-2">
                  <img src="/images/arrow.svg" alt="" />
                  <p className="web-body-md text-zinc-800">
                    <span className="font-semibold">
                      📜 Comprehensive Services:
                    </span>
                    Daily horoscopes, kundli reports, matchmaking, planetary
                    insights, and life guidance.
                  </p>
                </div>

                <div className="flex items-start gap-2">
                  <img src="/images/arrow.svg" alt="" />
                  <p className="web-body-md text-zinc-800">
                    <span className="font-semibold">
                      💎 Authentic Remedies:
                    </span>
                    Energized gemstones, rudraksha, yantras, and pujas for
                    balance and positivity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute top-[20%] right-0 hidden 2xl:block">
        <img src="/images/shape1.png" alt="" />
      </div>
    </section>
  );
}

export default GuidanceSection;
